import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getStore } from '../store/store';
import { SearchScope } from 'owa-search-service';
import getSearchScopeDisplayName from '../utils/getSearchScopeDisplayName';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import {
    onFolderScopeButtonClicked,
    onFolderScopeOptionSelected,
} from '../actions/internalActions';
import getFolderMenuOptions from '../utils/getFolderMenuOptions';
import { SearchScenarioId } from 'owa-search';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./FolderScope.scss');

export interface FolderScopeProps {
    onFolderScopeSelected?: (ev?: any, dismissAll?: boolean) => void;
}

export default observer(function FolderScope(props: FolderScopeProps) {
    const isFolderScopeVisible = getStore().isFolderScopeVisible;
    const newIsFolderScopeVisible = !isFolderScopeVisible;

    const onFolderButtonClick = React.useCallback(() => {
        onFolderScopeButtonClicked(newIsFolderScopeVisible, SearchScenarioId.Mail);
    }, [newIsFolderScopeVisible]);

    const onMenuItemClick = React.useCallback(
        (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => {
            const { key } = item;

            onFolderScopeOptionSelected(key);
            props.onFolderScopeSelected(ev, true);
        },
        []
    );

    if (!getStore().initialSearchScope) {
        return null;
    }

    const selectedSearchScope = getSelectedOption();
    let selectedFolderScope = getSearchScopeDisplayName(
        selectedSearchScope,
        true /* isSearchFromFolderScope*/
    );
    const menuItems: IContextualMenuItem[] = [];
    const items: IContextualMenuItem[] = getFolderMenuOptions(menuItems);
    //  For Firefox on Mac, when user clicks on folder scope the focus disappears from the search box.
    //  It does not recognize the folder scope id, so adding a wrapper div around it and verifying the component by parent div instead
    return (
        <div tabIndex={-1} id="folderScopeWrapperId" className={styles.searchFolderScopeWrapper}>
            <PrimaryButton
                id="folderScopeButtonId"
                className={
                    isFeatureEnabled('sea-colors')
                        ? styles.foldersScopeNeutral
                        : styles.foldersScope
                }
                onRenderText={onRenderText(selectedFolderScope)}
                styles={{
                    flexContainer: styles.flexContainer,
                }}
                onMenuClick={onFolderButtonClick}
                menuProps={{
                    items: items,
                    directionalHintFixed: true,
                    onItemClick: onMenuItemClick,
                    calloutProps: { calloutMaxHeight: 500, calloutMaxWidth: 200 },
                    gapSpace: 1,
                }}
            />
        </div>
    );
});

const onRenderText = (selectedFolderScope: string) => () => (
    <div className={styles.folderScopeText}>{selectedFolderScope}</div>
);

function getSelectedOption(): SearchScope {
    const { staticSearchScope: selectedSearchScope, advancedSearchViewState } = getStore();
    return advancedSearchViewState.selectedSearchScope || selectedSearchScope;
}
